import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IS_SWEDEN, LD_SHOW_STATS_AND_LIMITS } from '@/constants/constants';
import { selectUserPlayStats } from '@/store/selectors/userPlayStatsAndLimitsSelectors';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function useStatsAndLimits(): void {
  const statsAndLimits = useSelector(selectUserPlayStats);
  const showStatsAndLimits = localStorage.getItem(LD_SHOW_STATS_AND_LIMITS);
  const { openModal } = useModal();

  useEffect(() => {
    if (!IS_SWEDEN) {
      return;
    }

    if (statsAndLimits && showStatsAndLimits) {
      setTimeout(() => {
        openModal(MODALS.STATS_AND_LIMITS);
      }, 1500);
    }
  }, [statsAndLimits, showStatsAndLimits]);
}
